import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { WA_WINDOW } from '@ng-web-apis/common';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly window = inject<Window>(WA_WINDOW);

  public get isPlatformBrowserBot() {
    return /bot|google|baidu|bing|msn|teoma|slurp|yandex/i.test(this.window?.navigator?.userAgent);
  }

  public get isPlatformServer() {
    return isPlatformServer(this.platformId);
  }

  public get isPlatformBrowser() {
    return isPlatformBrowser(this.platformId);
  }

  public get isTrackable() {
    return this.isPlatformBrowser && !this.isPlatformBrowserBot;
  }
}
